/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { Employee } from './Employee';
import {
    EmployeeFromJSON,
    EmployeeFromJSONTyped,
    EmployeeToJSON,
    EmployeeToJSONTyped,
} from './Employee';

/**
 * 
 * @export
 * @interface SearchEmployeesResponse
 */
export interface SearchEmployeesResponse {
    /**
     * 
     * @type {Array<Employee>}
     * @memberof SearchEmployeesResponse
     */
    data: Array<Employee>;
    /**
     * 
     * @type {Pagination}
     * @memberof SearchEmployeesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the SearchEmployeesResponse interface.
 */
export function instanceOfSearchEmployeesResponse(value: object): value is SearchEmployeesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function SearchEmployeesResponseFromJSON(json: any): SearchEmployeesResponse {
    return SearchEmployeesResponseFromJSONTyped(json, false);
}

export function SearchEmployeesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchEmployeesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EmployeeFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function SearchEmployeesResponseToJSON(json: any): SearchEmployeesResponse {
      return SearchEmployeesResponseToJSONTyped(json, false);
  }

  export function SearchEmployeesResponseToJSONTyped(value?: SearchEmployeesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(EmployeeToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

